// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import './theme/fonts'; // 自前ホストのプレミアム日本語フォント
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import UpdateNotification from './components/UpdateNotification';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import ErrorBoundary from './components/ErrorBoundary';

// グローバルエラーハンドラー：特定のエラーを抑制する
window.addEventListener('error', (event) => {
  // クロスオリジンの "Script error." を抑制
  if (event.message === 'Script error.') {
    event.preventDefault();
    return true;
  }
  // ResizeObserver のループエラーを抑制（MUI/Reactでよく発生する無害なエラー）
  if (event.message?.includes('ResizeObserver loop')) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
});

// ResizeObserver エラーを完全に抑制（開発モードのオーバーレイ対策）
const resizeObserverErr = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends resizeObserverErr {
  constructor(callback: ResizeObserverCallback) {
    super((entries, observer) => {
      requestAnimationFrame(() => {
        callback(entries, observer);
      });
    });
  }
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ErrorBoundary>
          <App />
          <UpdateNotification />
        </ErrorBoundary>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Capacitor / ネイティブ環境では Service Worker を登録しない
const isNativeApp = typeof window !== 'undefined' &&
  (window.location.protocol === 'capacitor:' ||
   window.location.protocol === 'file:' ||
   (window as any).Capacitor?.isNativePlatform?.());

if (!isNativeApp) {
  serviceWorkerRegistration.register({
    onUpdate: (registration) => {
      console.log('New content is available; dispatching pwa-update event.');
      window.dispatchEvent(new CustomEvent('pwa-update'));
    },
    onSuccess: (registration) => {
      console.log('Service Worker registered successfully.');
    },
  });
} else {
  // Capacitor 環境では既存の Service Worker を全て解除
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(regs => {
      regs.forEach(r => r.unregister());
    }).catch(() => {});
  }
}

reportWebVitals();
